import React from 'react'
import PropTypes from 'prop-types'

const GroupHeaderContent = ({ customGroupHeaderContent, groupName, groupValue }) => {
  if (customGroupHeaderContent) {
    if (typeof customGroupHeaderContent === 'string') {
      return (
        <React.Fragment>
          <span className="fil-table--body-parent-row-title">{groupName}</span>
          <span className="fil-table--body-parent-row-note">{customGroupHeaderContent}</span>
        </React.Fragment>
      )
    }

    return customGroupHeaderContent({ groupName, groupValue })
  }
  return (
    <React.Fragment>
      <span className="fil-table--body-parent-row-title">{groupName}</span>
      <span className="fil-table--body-parent-row-note">{`(include ${groupValue.length} item(s))`}</span>
    </React.Fragment>
  )
}

GroupHeaderContent.propTypes = {
  customGroupHeaderContent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  groupName: PropTypes.string,
  groupValue: PropTypes.array
}

GroupHeaderContent.defaultProps = {
  customGroupHeaderContent: '',
  groupName: '',
  groupValue: []
}

export default GroupHeaderContent
